import { ListItem as MuiListItem, ListItemProps as MuiListItemProps } from '@mui/material';

export type ListItemProps = MuiListItemProps;

export const ListItem = MuiListItem;
